import { Link } from 'react-router-dom';

const STATS = [
  { value: '2000+', label: 'Projects Completed' },
  { value: '8+', label: 'Years Experience' },
  { value: '100%', label: 'Dustless Process' },
  { value: '5★', label: 'Client Satisfaction' },
];

export default function ResultSection() {
  return (
    <>
      {/* Stats Bar */}
      <section className="bg-[#c9a55a] py-12 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {STATS.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl md:text-4xl font-black text-[#0d0d0d] mb-1">{stat.value}</div>
                <div className="text-[#0d0d0d]/70 text-sm font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Result Statement */}
      <section className="relative bg-[#1c1a17] py-28 px-4 md:px-8 overflow-hidden">
        {/* Background image with overlay */}
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/c4da8ecd692d6061d9fe588fac4030f3.jpg"
            alt="VM Construction precision process"
            className="w-full h-full object-cover object-top opacity-15"
          />
          <div className="absolute inset-0 bg-[#1c1a17]/88" />
        </div>

        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-6">Our Approach</p>
          <h2 className="text-4xl md:text-6xl font-black text-white leading-tight mb-6">
            We don&apos;t just install floors.
            <br />
            <span className="text-[#c9a55a]">We fix what others ignore.</span>
          </h2>
          <p className="text-white/50 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto mb-12">
            From moisture issues to uneven subfloors — we solve the real problem before installing anything.
            That&apos;s why our floors last longer and perform better.
          </p>

          {/* Process Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
            {[
              { num: '01', title: 'Inspect', desc: 'We assess subfloor condition, moisture levels, and existing damage before any work begins.' },
              { num: '02', title: 'Prepare', desc: 'Leveling, repairs, and corrections — we create the perfect foundation for your new floor.' },
              { num: '03', title: 'Install', desc: 'Precision layout and flawless execution, followed by thorough quality control.' },
            ].map((step) => (
              <div key={step.num} className="bg-white/8 border border-white/10 rounded-2xl p-8 text-left">
                <div className="text-[#c9a55a]/40 text-5xl font-black mb-4">{step.num}</div>
                <h3 className="text-white font-bold text-xl mb-3">{step.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>

          <Link
            to="/contact"
            className="inline-flex items-center gap-3 bg-[#c9a55a] hover:bg-[#b8944a] text-[#0d0d0d] font-bold text-base px-10 py-4 rounded-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line" />
            Get a Free Estimate Today
          </Link>
        </div>
      </section>
    </>
  );
}
